import * as React from 'react';
import { noop } from '@deltasierra/utilities-object';
import { InfiniteScrollProps, InfiniteScroll } from '../InfiniteScroll';
import { CustomDropdown } from './CustomDropdown';

export type DropdownWithSearchButtonComponentProps = {
    onClick: React.MouseEventHandler;
};

export type DropdownWithSearchChildrenProps = {
    onClick: React.MouseEventHandler;
};

export type DropdownWithSearchProps = InfiniteScrollProps & {
    buttonComponent: (props: DropdownWithSearchButtonComponentProps) => React.ReactNode;
    onSearch?: (search: string) => void;
    renderDropdown: (props: DropdownWithSearchChildrenProps) => React.ReactNode;
    search?: string | null;
};

export const DropdownWithSearch: React.FunctionComponent<DropdownWithSearchProps> = ({
    buttonComponent,
    onSearch = noop,
    renderDropdown,
    search,
    ...rest
}) => (
    <CustomDropdown render={props => buttonComponent({ onClick: () => props.requestToggle() }) as any}>
        {({ requestClose }) => (
            <>
                <li style={{ padding: '0 0.5rem 0.5rem' }}>
                    <div className="input-group" style={{ width: '100%' }}>
                        <div className="form-group" style={{ marginLeft: 0, marginRight: 0 }}>
                            <input
                                className="form-control"
                                placeholder=""
                                type="text"
                                value={search ?? ''}
                                onChange={event => onSearch(event.target.value)}
                            />
                        </div>
                    </div>
                </li>
                <li>
                    <InfiniteScroll
                        {...rest}
                        style={{
                            height: '300px',
                            overflowY: 'auto',
                        }}
                    >
                        {renderDropdown({ onClick: requestClose })}
                    </InfiniteScroll>
                </li>
            </>
        )}
    </CustomDropdown>
);
